// extracted by mini-css-extract-plugin
export default {"pageContainer":"ProjectPage_pageContainer__HuEuo","projectsGrid":"ProjectPage_projectsGrid__AOApj","emptyState":"ProjectPage_emptyState__oMaNT"};